import { Alert, Box, Skeleton, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import LocationMultiselector from 'modules/locations/components/LocationMultiselector'
import { getSelectableTeams } from 'modules/shift_management/lib/getSelectableTeams'
import { useSelectableLocations } from 'modules/shift_management/lib/useSelectableLocations'
import TeamMultiselector from 'modules/teams/components/TeamMultiselector'

type IdsTypes = number[] | null

interface Props {
  locationsIds: IdsTypes
  setLocationsIds: (ids: number[]) => void
  teamsIds: IdsTypes
  setTeamsIds: (ids: number[]) => void
  hasSelectedTeamOrLocation: boolean
  canManageAllCompany: boolean | null | undefined
  setLocationsIdsSelection: (ids: number[]) => void
  setTeamsIdsSelection: (ids: number[]) => void
}

const TeamsLocationsSelector = ({
  locationsIds,
  setLocationsIds,
  teamsIds,
  setTeamsIds,
  hasSelectedTeamOrLocation,
  canManageAllCompany,
  setLocationsIdsSelection,
  setTeamsIdsSelection,
}: Props) => {
  const currentEmployee = users.current.employee
  const { loading, locations } = useSelectableLocations(currentEmployee?.id, !!canManageAllCompany)

  const scopedTeams = currentEmployee
    ? getSelectableTeams(currentEmployee.id, !!canManageAllCompany)
    : []

  const scopedTeamsIds = scopedTeams.map((team) => team.id)

  const onSelectedTeamsChanged = (ids: number[]) => {
    setTeamsIdsSelection(ids)
    setTeamsIds(ids)
  }

  const onSelectedLocationsChanged = (ids: number[]) => {
    setLocationsIdsSelection(ids)
    setLocationsIds(ids)
  }

  return (
    <Box gap="s24">
      <TeamMultiselector
        selectedTeamsIds={teamsIds}
        disabled={false}
        onSelectedTeamsChanged={onSelectedTeamsChanged}
        mandatory={!hasSelectedTeamOrLocation}
        scopedTeamIds={scopedTeamsIds}
      />
      {loading ? (
        <Skeleton width="full" height="s40" />
      ) : (
        <LocationMultiselector
          selectedLocationsIds={locationsIds}
          disabled={false}
          onSelectedLocationsChanged={onSelectedLocationsChanged}
          mandatory={!hasSelectedTeamOrLocation}
          locations={locations}
        />
      )}
      {!hasSelectedTeamOrLocation && (
        <Alert color="warning">
          <Text size="300">
            <b>{i18n.t('shift_management.export_annual_balance.modal.filter_alert_1')}</b>
            &nbsp;
            {i18n.t('shift_management.export_annual_balance.modal.filter_alert_2')}
          </Text>
        </Alert>
      )}
    </Box>
  )
}

export default observer(TeamsLocationsSelector)
